(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treasure-mascot"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const root = document.querySelector('.treasure');
    if (!root) return;

    const webhookUrl = root.dataset.treasureWebhook;
    if (!webhookUrl) { console.warn('[Treasure] No webhook URL'); return; }

    const modal = root.querySelector('[data-treasure-modal]');
    const modalMascotImg = root.querySelector('[data-treasure-mascot-img]');
    const emailInput = root.querySelector('[data-treasure-email]');
    const submitBtn = root.querySelector('[data-treasure-submit]');
    const errorEl = root.querySelector('[data-treasure-error]');
    const errorMsgEl = root.querySelector('[data-treasure-error-msg]');
    const errorTitleEl = root.querySelector('[data-treasure-error-title]');
    const codeEl = root.querySelector('[data-treasure-code]');
    const codeSavedEl = root.querySelector('[data-treasure-code-saved]');
    const copyBtn = root.querySelector('[data-treasure-copy]');
    const copySavedBtn = root.querySelector('[data-treasure-copy-saved]');
    const timerEl = root.querySelector('[data-treasure-timer]');

    const defaultTexts = {
      'found-eyebrow': 'Félicitations',
      'found-title': "Tu l'as trouvée !",
      'found-desc': 'Laisse ton email pour recevoir ton code promo exclusif.',
      'revealed-eyebrow': 'Ton code promo',
      'revealed-title': 'Utilise-le au checkout',
      'revealed-hint': "Continue la chasse, il y a d'autres mascottes cachées !",
      'exhausted-eyebrow': 'Oh non',
      'exhausted-title': 'Trop tard...',
      'exhausted-desc': "Cette mascotte a déjà été trouvée. Mais il y en a d'autres cachées sur le site. À toi de jouer !"
    };

    let currentWrap = null;
    let currentToken = null;
    let currentCode = null;
    let currentStorageKey = null;
    let timerInterval = null;

    function applyTexts(wrap) {
      Object.keys(defaultTexts).forEach(key => {
        const dataKey = 'text' + key.split('-').map(s => s.charAt(0).toUpperCase() + s.slice(1)).join('');
        const custom = wrap.dataset[dataKey];
        const value = (custom && custom.trim()) ? custom : defaultTexts[key];
        const el = root.querySelector('[data-treasure-text="' + key + '"]');
        if (el) el.textContent = value;
      });
    }

    function anchorMascot(wrap) {
      const selector = wrap.dataset.target;
      const anchor = wrap.dataset.anchor || 'top-right';
      const offsetX = parseInt(wrap.dataset.offsetX, 10) || 0;
      const offsetY = parseInt(wrap.dataset.offsetY, 10) || 0;
      const size = parseInt(wrap.dataset.size, 10) || 60;

      wrap.style.width = size + 'px';
      wrap.style.height = size + 'px';

      if (!selector) { wrap.style.display = 'none'; return; }

      const target = document.querySelector(selector);
      if (!target) {
        wrap.style.display = 'none';
        console.warn('[Treasure] Target not found:', selector);
        return;
      }

      const rect = target.getBoundingClientRect();
      const scrollY = window.scrollY || window.pageYOffset;
      const scrollX = window.scrollX || window.pageXOffset;

      let top, left;
      switch (anchor) {
        case 'top-left':
          top = rect.top + scrollY + offsetY;
          left = rect.left + scrollX + offsetX;
          break;
        case 'top-right':
          top = rect.top + scrollY + offsetY;
          left = rect.right + scrollX - size + offsetX;
          break;
        case 'bottom-left':
          top = rect.bottom + scrollY - size + offsetY;
          left = rect.left + scrollX + offsetX;
          break;
        case 'bottom-right':
          top = rect.bottom + scrollY - size + offsetY;
          left = rect.right + scrollX - size + offsetX;
          break;
        case 'center':
          top = rect.top + scrollY + (rect.height / 2) - (size / 2) + offsetY;
          left = rect.left + scrollX + (rect.width / 2) - (size / 2) + offsetX;
          break;
        default:
          top = rect.top + scrollY + offsetY;
          left = rect.left + scrollX + offsetX;
      }

      wrap.style.position = 'absolute';
      wrap.style.top = top + 'px';
      wrap.style.left = left + 'px';
      wrap.style.display = 'block';
    }

    function anchorAll() {
      root.querySelectorAll('[data-treasure-mascot]').forEach(anchorMascot);
    }

    function showState(state) {
      root.querySelectorAll('[data-treasure-state]').forEach(el => {
        el.hidden = el.dataset.treasureState !== state;
      });
    }

    function openModal() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      stopTimer();
      if (errorEl) errorEl.hidden = true;
      if (emailInput) emailInput.value = '';
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Recevoir mon code'; }
    }

    function startTimer(seconds) {
      let remaining = seconds;
      updateTimer(remaining);
      timerInterval = setInterval(() => {
        remaining--;
        if (remaining <= 0) {
          stopTimer();
          showError('Temps écoulé', 'Ta réservation a expiré. Réessaie pour réclamer le code.');
          return;
        }
        updateTimer(remaining);
      }, 1000);
    }

    function stopTimer() {
      if (timerInterval) { clearInterval(timerInterval); timerInterval = null; }
    }

    function updateTimer(seconds) {
      const m = Math.floor(seconds / 60);
      const s = seconds % 60;
      timerEl.textContent = m + ':' + String(s).padStart(2, '0');
    }

    function showError(title, msg) {
      errorTitleEl.textContent = title;
      errorMsgEl.textContent = msg;
      showState('error');
    }

    async function handleMascotClick(wrap, btn) {
      const mascotId = wrap.dataset.mascotId;
      const storageKey = btn.dataset.storageKey;
      currentWrap = wrap;
      currentStorageKey = storageKey;

      applyTexts(wrap);

      const img = btn.querySelector('img');
      if (img) modalMascotImg.src = img.src;

      const saved = localStorage.getItem(storageKey);
      if (saved) {
        try {
          const data = JSON.parse(saved);
          if (data.code) {
            codeSavedEl.textContent = data.code;
            showState('already');
            openModal();
            return;
          }
        } catch (e) {}
      }

      showState('loading');
      openModal();

      try {
        const res = await fetch(webhookUrl + '?step=claim', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ mascot_id: mascotId })
        });
        const data = await res.json();

        if (data.success) {
          currentToken = data.token;
          currentCode = data.code;
          showState('found');
          startTimer(data.expires_in || 300);
          setTimeout(() => emailInput.focus(), 200);
        } else if (data.reason === 'exhausted') {
          showState('exhausted');
        } else {
          showError('Erreur', 'Impossible de réserver la mascotte. Réessaie.');
        }
      } catch (e) {
        console.error('[Treasure] Claim failed', e);
        showError('Erreur réseau', 'Vérifie ta connexion et réessaie.');
      }
    }

    async function handleSubmit() {
      const email = emailInput.value.trim();
      errorEl.hidden = true;

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errorEl.textContent = 'Email invalide';
        errorEl.hidden = false;
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = 'Envoi...';

      try {
        const mascotId = currentWrap.dataset.mascotId;
        const res = await fetch(webhookUrl + '?step=confirm', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ mascot_id: mascotId, token: currentToken, email: email })
        });
        const data = await res.json();

        if (data.success) {
          stopTimer();
          localStorage.setItem(currentStorageKey, JSON.stringify({
            code: currentCode, email: email, claimed_at: new Date().toISOString()
          }));
          codeEl.textContent = currentCode;
          currentWrap.setAttribute('data-claimed', 'true');
          showState('revealed');
        } else {
          errorEl.textContent = data.reason === 'expired'
            ? 'Réservation expirée, réessaie.'
            : 'Erreur : ' + (data.reason || 'inconnue');
          errorEl.hidden = false;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Recevoir mon code';
        }
      } catch (e) {
        console.error('[Treasure] Confirm failed', e);
        errorEl.textContent = 'Erreur réseau';
        errorEl.hidden = false;
        submitBtn.disabled = false;
        submitBtn.textContent = 'Recevoir mon code';
      }
    }

    function handleCopy(target) {
      const text = target === 'saved' ? codeSavedEl.textContent : codeEl.textContent;
      const btn = target === 'saved' ? copySavedBtn : copyBtn;

      const showSuccess = () => {
        const original = btn.textContent;
        btn.textContent = 'Copié ✓';
        setTimeout(() => { btn.textContent = original; }, 1500);
      };

      const fallbackCopy = () => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        textarea.style.left = '-9999px';
        textarea.setAttribute('readonly', '');
        document.body.appendChild(textarea);
        textarea.select();
        textarea.setSelectionRange(0, text.length);
        try {
          document.execCommand('copy');
          showSuccess();
        } catch (e) {
          btn.textContent = 'Copie impossible';
          setTimeout(() => { btn.textContent = 'Copier le code'; }, 2000);
        }
        document.body.removeChild(textarea);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(showSuccess).catch(fallbackCopy);
      } else {
        fallbackCopy();
      }
    }

    root.querySelectorAll('[data-treasure-mascot]').forEach(wrap => {
      const btn = wrap.querySelector('.treasure__mascot');
      const storageKey = btn.dataset.storageKey;
      if (localStorage.getItem(storageKey)) {
        wrap.setAttribute('data-claimed', 'true');
      } else {
        btn.classList.add('treasure__mascot--pulse');
      }
      btn.addEventListener('click', () => handleMascotClick(wrap, btn));
    });

    root.querySelectorAll('[data-treasure-close]').forEach(el => {
      el.addEventListener('click', closeModal);
    });

    submitBtn.addEventListener('click', handleSubmit);
    emailInput.addEventListener('keydown', e => {
      if (e.key === 'Enter') { e.preventDefault(); handleSubmit(); }
    });

    copyBtn.addEventListener('click', () => handleCopy('current'));
    copySavedBtn.addEventListener('click', () => handleCopy('saved'));

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    anchorAll();
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(anchorAll, 100);
    });
    window.addEventListener('load', anchorAll);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(anchorAll);
    }
    setTimeout(anchorAll, 500);
    setTimeout(anchorAll, 1500);
  })();

  } catch(e) { console.error(e); }
})();
})();
